import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SyncSharpIcon from '@mui/icons-material/SyncSharp';
import { FormattedMessage } from 'react-intl';
import { SmartDiaryListTabValue } from './hooks/useSmartDiaryTabs';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  box: {
    display: 'flex',
    justifyContent: 'center'
  },

  rebrandingIcon: {
    color: theme.palette.timesheetLabel.customLabelChipColor,
    fontSize: theme.spacing(22),
    opacity: '50%',
    height: theme.spacing(18.5),
    width: theme.spacing(18.5),
    maxWidth: '350px'
  },

  title: {
    margin: theme.spacing(5, 0, 0, 0),
    fontWeight: theme.typography.h3.fontWeight,
    color: theme.palette.text.primary
  },
  rebrandingTitle: {
    margin: theme.spacing(5, 5, 5, 5),
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.text.secondary
  },
  rebrandingSubtitle: {
    margin: theme.spacing(0, 5, 0, 5),
    color: theme.palette.text.primary
  }
}));

interface SmartDiaryEmptyPageProps {
  tabValue: SmartDiaryListTabValue;
}

export const SmartDiaryEmptyPage: React.FC<SmartDiaryEmptyPageProps> = ({
  tabValue
}: SmartDiaryEmptyPageProps) => {
  const classes = useStyles();

  const rebrandingTitle = useMemo(() => {
    return `smartDiary.empty.${tabValue.toLowerCase()}.rebrandingTitle`;
  }, [tabValue]);

  const rebrandingSubTitle = useMemo(() => {
    return `smartDiary.empty.${tabValue.toLowerCase()}.rebrandingSubtitle`;
  }, [tabValue]);

  return (
    <div
      className={classes.wrapper}
      data-testid={`smart-diary-empty-page_${tabValue}`}
    >
      <Box className={classes.box}>
        <SyncSharpIcon className={classes.rebrandingIcon} />
      </Box>
      <Box className={classes.box} tabIndex={0}>
        <Typography
          variant="h4"
          textAlign="center"
          className={classes.rebrandingTitle}
        >
          <FormattedMessage id={rebrandingTitle} />
        </Typography>
      </Box>
      <Box className={classes.box} tabIndex={0}>
        <Typography
          variant="subtitle1"
          align="center"
          className={classes.rebrandingSubtitle}
        >
          {<FormattedMessage id={rebrandingSubTitle} />}
        </Typography>
      </Box>
    </div>
  );
};
